import React, { FC, useRef } from 'react';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import { useMenuCategoryGroups } from '../../hooks/useMenuCategoryGroups';

import s from './MegaMenu.scss';
import { useTemplatesPageUI } from '../../contexts/TemplatesPageUIContext';
import { useExperiments } from '../../contexts/ExperimentsContext';
import { CategorySlug } from '../../config';

interface MegaMenuProps {
  onCategoryClick: (slug: string) => void;
}
export const MegaMenu: FC<MegaMenuProps> = ({ onCategoryClick }) => {
  const { is } = useExperiments();
  const menuCategoryGroups = useMenuCategoryGroups();
  const { isCategoriesMenuOpen } = useTemplatesPageUI();
  const contentRef = useRef<HTMLDivElement>(null);

  const isNewMegaMenu = is('specs.funnel.StudioTemplatesMegaMenuNewUi', 'true');
  const titleClassname = isNewMegaMenu ? s.titleNew : s.title;
  const bucketClassname = isNewMegaMenu ? s.bucketNew : s.bucket;
  const listClassname = isNewMegaMenu ? s.listNew : s.list;
  const linkClassname = isNewMegaMenu ? s.linkNew : s.link;

  return (
    <div className={cs(s.container, { [s.open]: isCategoriesMenuOpen })}>
      <div className={s.content} ref={contentRef}>
        {menuCategoryGroups.map(({ title, categories }, index) => (
          <div className={s.bucketWrapper} key={title}>
            <div className={bucketClassname}>
              <div className={titleClassname}>{title}</div>
              <ol
                className={cs(listClassname, {
                  [s.twoColumn]: categories.length > 5 && index != 2,
                  [s.twoColumnNew]: categories.length > 8 && index === 2,
                })}
              >
                {categories.map(({ label, url, slug, isActive }) => (
                  <li className={s.item} key={slug}>
                    <Link
                      to={url}
                      className={cs(linkClassname, { [s.active]: isActive })}
                      onClick={() => onCategoryClick(slug)}
                      data-hook={`mega-menu-category-link-${slug}`}
                    >
                      {categoriesIcons[slug] && isNewMegaMenu && (
                        <div
                          className={cs(s.circle, categoriesIcons[slug])}
                        ></div>
                      )}
                      <span className={s.linkLabel} data-text={label}>
                        {label}
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const categoriesIcons: Record<string, string> = {
  [CategorySlug.DARK]: s.circleDark,
  [CategorySlug.BRIGHT]: s.circleWhite,
  [CategorySlug.GRADIENT]: s.circleGradient,
  [CategorySlug.BLACK_WHITE]: s.circleBw,
  [CategorySlug.NEON]: s.circleNeon,
};
